export default class InformationButtonBasic {
    constructor() {
      this.id = 'moreInformationButtonBasic';
    }
  
    getHtml() {
      const styles = 'class="btn btn--yellow btn--width-100 btn--48-lg loading"';
      return `<button data-qa="learn-more-button" id="${this.id}" ${styles}>Learn More</button>`;
    }
  
    getNode() {
      return document.getElementById(this.id);
    }
  }
  